<template>
  <div>
      <Details></Details>
  </div>
</template>

<script>
import Details from '@/components/Details';

export default {
  components: {
    Details,
  },
};
</script>
